import Analytics from '@withlocals/withlocals-analytics';
import {
  BookingsResponse,
  cancelBookingAsHost as cancelBookingAsHostCall,
  cancelOrTransferBookingAsHost as cancelOrTransferBookingAsHostCall,
  confirmBooking as confirmBookingCall,
  fetchBooking as fetchBookingCall,
  rejectBooking as rejectBookingCall,
  withdrawOffer as withdrawOfferCall,
} from 'flux/clients/bookings';
import Trip from 'model/ITrip';

import ActionTypes from './ActionTypes';

export interface Actions {
  fetchBooking: (options: { id: string }) => Promise<BookingsResponse>;
  confirmBooking: (options: {
    id: string;
    selectedCurrency: string;
  }) => Promise<BookingsResponse>;
  cancelBookingAsHost: (options: {
    id: string;
    cancelExplanation: string;
    selectedCurrency: string;
  }) => Promise<BookingsResponse>;
  cancelOrTransferBookingAsHost: (options: {
    id: string;
    cancelExplanation: string;
  }) => Promise<Trip>;
  rejectBooking: (options: {
    id: string;
    selectedCurrency: string;
  }) => Promise<BookingsResponse>;
  withdrawOffer: (options: {
    id: string;
    selectedCurrency: string;
  }) => Promise<BookingsResponse>;
}

export default function (dispatch: (action: ActionTypes) => void): Actions {
  const fetchBooking = async ({ id, selectedCurrency }) => {
    dispatch({ type: 'BOOKING:FETCHING', payload: { id } });
    try {
      const result = await fetchBookingCall(id);
      dispatch({
        type: 'BOOKING:FETCHING_SUCCESS',
        payload: { id, result },
      });
      return result;
    } catch (error) {
      dispatch({ type: 'BOOKING:FETCHING_ERROR', payload: { id, error } });
      return error;
    }
  };

  return {
    fetchBooking,
    confirmBooking: async ({ id, selectedCurrency }) => {
      Analytics.track('Booking environment', 'Confirm booking', id);
      await confirmBookingCall({ id });
      return await fetchBooking({ id, selectedCurrency });
    },
    cancelBookingAsHost: async ({
      id,
      cancelExplanation,
      selectedCurrency,
    }) => {
      Analytics.track('Booking environment', 'Cancel booking', 'Host');
      await cancelBookingAsHostCall({
        id,
        cancelExplanation,
      });
      return await fetchBooking({ id, selectedCurrency });
    },
    cancelOrTransferBookingAsHost: async ({ id, cancelExplanation }) => {
      Analytics.track(
        'Booking environment',
        'Cancel or transfer booking',
        'Host',
      );
      return await cancelOrTransferBookingAsHostCall({
        id,
        cancelExplanation,
      });
    },
    rejectBooking: async ({ id, selectedCurrency }) => {
      Analytics.track('Booking environment', 'Reject booking', id);
      await rejectBookingCall({ id });
      return await fetchBooking({ id, selectedCurrency });
    },
    withdrawOffer: async ({ id, selectedCurrency }) => {
      Analytics.track('Booking environment', 'Withdraw personalised offer', id);
      await withdrawOfferCall({ id });
      return await fetchBooking({ id, selectedCurrency });
    },
  };
}
